import {useEffect} from 'react';
import {startUI} from '~/modules/firebase';
import {Header} from '../components';

export const LoginScene = () => {
  useEffect(() => {
    startUI();
  }, []);
  return (
    <div className="bg-background min-h-screen">
      <Header />
      <div id="firebaseui-auth-container" className="p-8" />
    </div>
  );
};
